module.exports = "/_next/static/images/swiggy-f00e1120b0470b4fb75aa5ead338ec6c.png";